export default __webpack_public_path__ + "static/media/bernay2.b9c2d4cb.jpg";